import styles from "./banner.module.scss";
import { Form } from "react-bootstrap";
import ResultSet from "../ResultSet/ResultSet";
import useStore from "../../store";
import ResultGroup from "../ResultGroup/ResultGroup";

const Banner = () => {
  const { resultSets, resultGroups, themeSettings } = useStore();
  const activeResultSetGroupName = resultSets.find(
    (set) => set.isActive
  )?.groupName;

  const activeResultGroup =
    resultGroups.find((group) => group.name === activeResultSetGroupName)
      ?.name || "";
  const activeGroupResultSets = resultSets.filter(
    (set) => set.groupName === activeResultGroup
  );

  const bannerImg = themeSettings?.params
    ? themeSettings.params.params.$bannerImage
    : "";

  return (
    <div className={styles.banner}>
      <div className={styles.bannerContent}>
        <div
          className={styles.bannerImg}
          style={{ background: `${bannerImg} center / cover no-repeat` }}
        />
        <div className={styles.tabsContainer}>
          <div className={styles.resultGroupsContainer}>
            {resultGroups.length > 1 &&
              resultGroups.map((group, key) => (
                <ResultGroup
                  name={group.name}
                  isActive={activeResultSetGroupName === group.name}
                  key={`group${group.name}${key}`}
                />
              ))}
          </div>
          <div className={styles.resultSetsContainer}>
            {activeGroupResultSets.length > 1 &&
              activeGroupResultSets.map((set) => (
                <ResultSet resultSet={set} key={`set${set.id}`} />
              ))}
          </div>
          {false && (
            <div className={styles.changeTicketType}>
              <Form.Select>
                <option value="1">Arabian warior 5k</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
